<template>
  <HeaderMenuVue :menu-color="'strategy'"></HeaderMenuVue>
  <div class="detail_originalBox"
       @scroll="handleScroll">
    <div class="detail_box"
         @scroll="handleScroll">
      <div class="detail_contentBox">
        <div class="detail_leftBox"></div>
        <div class="detail_middleBox">
          <div class="content">
            <div class="titleHead">
              <div class="title">{{ previewData.title }}</div>
              <div class="titleDesc">
                <div>{{ previewData.previewTime }}</div>
                <div class="rightDesc">{{ $t('home.CmsContent.rightDesc') }}</div>
              </div>
            </div>
            <div class="contentBox"
                 v-html="previewData.content">
            </div>
            <div class="footerBox">
              <div class="leftTitle"
                   @click="jumpArticle(beforeAfterData?.previous.id as number)">
                {{ $t('home.CmsContent.leftTitle') }}
                <span style="color:#cccccc;margin:0 7px 0 7px">|</span>
                <span>
                  {{ beforeAfterData?.previous?.title }}
                </span>
              </div>
              <div class="rightTitle"
                   @click="jumpArticle(beforeAfterData?.next.id as number)">
                {{ $t('home.CmsContent.rightTitle') }}
                <span style="color:#cccccc;margin:0 7px 0 7px">|</span>
                <span>
                  {{ beforeAfterData?.next?.title }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_rightBox"
             :style="{ transform: `translateY(${scrollDistance}px)` }">
          <div class="popular_article">
            <div class="article_title">
              <span>{{ $t('home.CmsContent.articleTitle') }}</span>
            </div>
            <ul class="ul_article">
              <li v-for="item, index in popularList">
                <a :key="index"
                   :href="(item.id as any)"
                   :title="item.title">{{ item.title }}</a>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getArticleBeforeAfter, getArticleFromSector, getSingleContent } from '../api/index'
import type { beforeAfterContent, sectorType } from '../api/interface/sectorinterface'
import { useHomeStore } from '../index'
import HeaderMenuVue from './components/HeaderMenu.vue'
import Footer from './components/Footer.vue'
import { useRoute, useRouter } from 'vue-router'
const storeState = useHomeStore()
const router = useRouter()
const previewData = ref<any>(storeState.cmsContentItem)
const beforeAfterData = ref<beforeAfterContent>()
const { params } = useRoute()
const popularList = ref<sectorType['contents']>()
const scrollDistance = ref(0)

onMounted(async () => {
  getSingleContent(params.id as string).then(result => {
    previewData.value = result
    const createdDate = new Date(previewData.value.createdAt)
    previewData.value.previewTime = createdDate.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).replace(/\//g, '-')
    getArticleFromSector(previewData.value.sector_id, { limit: 7, offset: 1 }).then(result => {
      popularList.value = result.rows
    })
    getArticleBeforeAfter(previewData.value.id).then(result => {
      beforeAfterData.value = result
    })
  })
})

const handleScroll = (event: any) => {
  scrollDistance.value = event.target.scrollTop

}

const jumpArticle = (id: number) => {
  router.push({
    path: "/posts/content/" + id,
  }).then(() => {
    window.location.reload()
  })

}

</script>

<style scoped lang="less">
.detail_originalBox {
  height: 100%;
  overflow: auto
}

.detail_box {
  width: 100%;
  height: auto;
  min-height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
}

.detail_contentBox {
  width: 100%;
  height: auto;
  display: inline-flex;

  .detail_leftBox {
    height: 100%;
    width: 15%;
  }

  .detail_middleBox {
    flex: 1;
    height: auto;
    margin-top: 25px;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .content {
      flex: 1;
      height: auto;
      background-color: #fff;
    }

    .titleHead {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column
    }

    .title {
      width: 100%;
      font-size: 40px;
      color: #111111;
    }

    .titleDesc {
      width: 100%;
      font-size: 14px;
      color: #999999;
      margin: 45px 0 20px 0;

      .rightDesc {
        float: right;
      }

      div {
        display: inline;
        font-weight: 300;
      }

      div:first-child {
        margin-right: 5px;
      }
    }

    .contentBox {
      flex: 1;
      height: 100%;
      min-height: 500px;
    }

    .footerBox {
      width: 100%;
      height: 60px;
      margin: 50px 0 100px 0;
      background: #f6f6f6;
      display: flex;
      align-items: center;

      .leftTitle {
        flex: 0.5;
        margin-left: 30px;
        color: #111111;
        font-size: 14px;
        cursor: pointer;
      }

      .rightTitle {
        flex: 0.5;
        color: #999999;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .detail_rightBox {
    height: 100%;
    width: 30%;
    margin-top: 25px;
    position: sticky;

    .popular_article {
      width: 300px;
      margin-left: 20px;
      height: 671px;
      padding: 10px;
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);

      .article_title {
        border-bottom: 1px solid #f6f6f6;
        margin: 10px;
        height: 61px;

        span {
          font-size: 20px;
          color: #111111;
          line-height: 21px;
          padding-bottom: 4px;
        }
      }

      .article_items {
        display: block;
        position: relative;
        margin-top: 6px;
        padding: 5px 5px 5px 56px;
        height: 50px;
        border: 1px solid #e8e8e8;

        &_image {
          position: absolute;
          top: 0;
          left: 0;
          width: 49px;
          height: 48px;
          background-size: cover;
        }

        &_text {
          color: #161616;
          font-weight: 400;
          height: 40px;
          font-size: 13px;
          overflow: hidden;
        }
      }

      .ul_article {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: baseline;
        margin: 0 30px 30px 30px;

        li {

          a {
            font-size: 14px;
            color: #999999;
          }

          color: #999999;
          margin-top: 19px;
          list-style: disc;
        }
      }
    }
  }
}
</style>
